import { useAuth } from '../../contexts/AuthContext'
import { useCharacterSpells } from '../../hooks/useUserSpells'
import { SPELL_LEVELS } from '../../lib/spellSchools'
import SpellCard from './SpellCard'
import './SpellCard.css'

/**
 * Spellbook section for CharacterDetailPage.
 * Shows granted spells if the viewer has access.
 */
export default function CharacterSpellbook({ characterId, linkedUserId }) {
  const { user, isOwner } = useAuth()
  const { spells, loading } = useCharacterSpells(characterId)

  // Access check: only show to owner or the character's linked player
  const canView = isOwner || (user && user.uid === linkedUserId)

  if (!canView) return null
  if (loading) return null
  if (spells.length === 0) return null

  // Group spells by level
  const spellsByLevel = SPELL_LEVELS.reduce((acc, lvl) => {
    acc[lvl.value] = spells.filter(s => s.level === lvl.value)
    return acc
  }, {})

  // Get levels that have spells
  const levelsWithSpells = SPELL_LEVELS.filter(lvl => spellsByLevel[lvl.value].length > 0)

  return (
    <section className="character-spellbook">
      <div className="spellbook-header">
        <h2>Spellbook</h2>
      </div>

      {levelsWithSpells.map(lvl => (
        <div key={lvl.value} className="spell-level-group">
          <h3>{lvl.label}s</h3>
          <div className="spell-grid">
            {spellsByLevel[lvl.value].map(spell => (
              <SpellCard key={spell.id} spell={spell} />
            ))}
          </div>
        </div>
      ))}
    </section>
  )
}
